// extracted by mini-css-extract-plugin
export default {"list":"lineage_list__49184"};